import React, { useEffect } from "react";
import { unstable_useBlocker as useBlocker } from "react-router-dom";

import { UnsavedChangesModal } from "./UnsavedChangesModal";

type ConfirmNavigationProps = {
  when: boolean;
  message?: string;
};

export const ConfirmNavigation: React.FC<ConfirmNavigationProps> = ({
  when,
  message,
}) => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      when && currentLocation.pathname !== nextLocation.pathname,
  );

  const isBlocked = blocker.state === "blocked";

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (!when) return;
      event.preventDefault();
      event.returnValue = "";
    };

    if (when) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [when]);

  const handleConfirm = () => {
    if (blocker.proceed) {
      blocker.proceed();
    }
  };

  const handleCancel = () => {
    if (blocker.reset) {
      blocker.reset();
    }
  };

  return (
    <UnsavedChangesModal
      open={isBlocked}
      message={message}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    />
  );
};
